import { Check, Edit } from "@mui/icons-material";
import { Box, IconButton, Table, TableBody, TableCell, TableRow, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function TransferDetails({transfer, setBookingByBookingId, orderId, userId, type}) {

    const { t } = useTranslation();
    const [editAddress, setEditAddress] = useState(false);
    const [address, setAddress] = useState('');

    const saveAddress = () => {

        axios.patch(`/api/my-booking/customers/${userId}/orders/${orderId}/update-transfer-addresses`, {
            [type]: address
        }).then(() => {
            setEditAddress(false);
            setBookingByBookingId();
        })
        
    }

    const editAddressAction = () => {
        setEditAddress(true);
        setAddress(transfer?.fromAirport?transfer.dropoffAddress:transfer.pickupAddress);
    }

    return (
        <Box>
            <Typography sx={{ fontSize: '18px', fontWeight: 300, textAlign: 'left', fontWeight: 'bold' }}>
                {transfer?.name}
            </Typography>
            <Table>
                <TableBody>
                <TableRow>
                        <TableCell>
                            Offer:
                        </TableCell>
                        <TableCell>
                            {transfer?.offerId}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Address:
                        </TableCell>
                        <TableCell>
                            {editAddress
                            ?<TextField size="small" value={address} onChange={(e) => setAddress(e?.target?.value)} />
                            :transfer?.fromAirport?transfer.dropoffAddress:transfer.pickupAddress}
                            {editAddress?
                            <IconButton onClick={(() => saveAddress())}>
                                <Check />
                            </IconButton>
                            :
                            <IconButton onClick={(() => editAddressAction())}>
                                <Edit />
                            </IconButton>}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Airport:
                        </TableCell>
                        <TableCell>
                            {transfer?.airportCode}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Description:
                        </TableCell>
                        <TableCell>
                            {transfer?.description}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Box>
    );
}

export default TransferDetails;
